// extracted by mini-css-extract-plugin
export default {"container":"PageSizeSelect_container__mJCP3","select":"PageSizeSelect_select__Lq7Kt"};